import 'react-phone-number-input/style.css';
import 'react-toastify/dist/ReactToastify.css';
import '@material/react-button/dist/button.css';
import '@material/react-text-field/dist/text-field.css';
import '@material/react-select/dist/select.css';
import '@material/react-dialog/dist/dialog.css';
import './assets/scss/style.scss';
import './assets/css/style.css';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'components';
import configureStore from 'config/store';
import { ToastContainer, Zoom } from 'react-toastify';
import FullScreenLoader from 'components/Loader/FullScreenLoader';
import UserProvider from 'contexts/user.context';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'lib';
import { WebSocketProvider } from 'contexts/webSocketcontext';
import { WS_API_URL } from 'config/constants';
import { initAmplitude } from './utils/Analytics/amplitude';
import SubscriptionExpire from './components/SubscriptionExpire';
import router from './components/Router';
import ScriptLoader from './components/ScriptLoader';
import { Logger } from 'utils/logger';

export const store = configureStore();

function App() {
  useEffect(() => {
    // Enable this if you want freshwork
    // window.FreshworksWidget('hide', 'launcher');
    initAmplitude();

    /**
     * Dynamic imports crash handler
     */
    window.addEventListener('vite:preloadError', (event) => {
      Logger.error({
        message: 'Vite Preload Error',
        data: event,
      });
      window.location.reload();
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <UserProvider>
          <ErrorBoundary>
            <SubscriptionExpire />
            <WebSocketProvider url={`${WS_API_URL}/ws/download/`}>
              <ErrorBoundary>
                <ScriptLoader />
                <RouterProvider router={router} />

                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss={false}
                  draggable
                  pauseOnHover
                  transition={Zoom}
                  limit={1}
                />
                <FullScreenLoader />
              </ErrorBoundary>
            </WebSocketProvider>
          </ErrorBoundary>
        </UserProvider>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
